import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AgencyStateService } from '../services/agency-state.service';

export const defaultRedirectGuard: CanActivateFn = async () => {
  const agencyState = inject(AgencyStateService);
  const router = inject(Router);

  await agencyState.ensureInitialized();

  if (agencyState.isAgency()) {
    router.navigate(['/agency/dashboard']);
  } else {
    router.navigate(['/dashboard']);
  }

  return false;
};
